$(document).ready(function () {
    $('#faq_container ul:first > li.faq-list__item').on('click', function (e) {
        e.preventDefault()
        let dropdown = $(this).next('.faq-list')
        dropdown.toggleClass('closed')

        if (dropdown.hasClass('closed')) {
            $(this).find('.faq-list__dropdown--arrow').attr('src', '/images/icons/arrow-down.svg')
        } else {
            $(this).find('.faq-list__dropdown--arrow').attr('src', '/images/icons/arrow-up.svg')
        }
    })

    $('#faq_container ul ul > li.faq-list__item').on('click', function (e) {
        let dropdown = $(this).find('.faq-list__dropdown__sub')
        dropdown.toggleClass('closed')

        if (dropdown.hasClass('closed')) {
            $(this).find('.faq-list__dropdown--arrow').attr('src', '/images/icons/arrow-down.svg')
        } else {
            $(this).find('.faq-list__dropdown--arrow').attr('src', '/images/icons/arrow-up.svg')
        }
    })
})
